<template>
  <div class="dashboard">
    <Content />
  </div>
</template>

<script>
import Content from '@/components/dashboard/Content.vue'
export default {
  name: 'DashboardLayout',
  components: { 
    Content,
  },
}
</script>

<style lang="scss" scoped>
.dashboard {
  display: grid;
  grid-template-columns: 250px calc(100% - 250px);
  grid-template-rows: 65px calc(100% - 65px);
  grid-template-areas: 
    'content            content'
    'content            content'
  ;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: $light-card;
  > .content {
    margin-left: 0px;
  }
}
</style>